import { render, staticRenderFns } from "./PreFooter.vue?vue&type=template&id=a67d0af6&scoped=true&"
import script from "./PreFooter.vue?vue&type=script&lang=js&"
export * from "./PreFooter.vue?vue&type=script&lang=js&"
import style0 from "./PreFooter.vue?vue&type=style&index=0&id=a67d0af6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67d0af6",
  null
  
)

export default component.exports